var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSyncAborted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 20,
    viewBox: "0 0 20 20",
    width: 20,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 18.333A8.326 8.326 0 011.667 10v-.167a8.338 8.338 0 0114.228-5.728A8.333 8.333 0 0110 18.333zm0-7.158l2.158 2.158 1.175-1.175L11.175 10l2.158-2.158-1.175-1.175L10 8.825 7.842 6.667 6.667 7.842 8.825 10l-2.158 2.158 1.175 1.175L10 11.176z",
    fill: "#ca4139"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSyncAborted);
export default __webpack_public_path__ + "static/media/sync_aborted.b2ef72f0332b0130e44b94a19d8c14a1.svg";
export { ForwardRef as ReactComponent };